import type { Friend } from './friends';
import { escapeSignInText as escape } from './sign-in-form';

export function renderFriendsList(friends: Friend[], error: string): string {
  if (error) return `<p class="card-copy" role="status">${escape(error)}</p>`;
  if (!friends.length) return '<p class="card-copy">No friends yet. Add someone from a workout, or accept a workout invitation.</p>';
  return `<ul class="friends-list">${friends.map((friend) => `<li>${escape(friend.username)}</li>`).join('')}</ul>`;
}

export function renderParticipantFriend(friend: Friend, added: boolean, pending: boolean): string {
  if (added) return '<span class="friend-label">Friend</span>';
  return `<button class="btn-secondary add-friend-btn" type="button" data-add-friend="${escape(friend.userId)}"
    aria-label="Add ${escape(friend.username)} as a friend" title="Add friend" ${pending ? 'disabled' : ''}>${pending ? '…' : '+'}</button>`;
}
